module.exports = __webpack_public_path__ + "static/media/strava-logo.09400244.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/strava-logo.svg
// module id = 723
// module chunks = 0